import { unselectedColorState, unselectedState } from 'src/constants'

// 全ポジションで使うカラー情報
export const colorInitialState = {
  parts: { label: '全体', value: 'all' },
  all: unselectedColorState,
  catchFace: unselectedColorState,
  edge: unselectedColorState,
  lace: unselectedColorState,
  linings: unselectedColorState,
  hamidashi: unselectedColorState,
  stitch: unselectedColorState,
  web: unselectedColorState,
  web2: unselectedColorState,
  thumbHook: unselectedColorState,
  littleHook: unselectedColorState,
  listBelt: unselectedColorState,
  indexCover: unselectedColorState,
  mouton: unselectedColorState,
  atomsLabel: unselectedState
}

// 投・内・外で使うカラー情報
export const gloveColorInitialState = {
  thumbOut: unselectedColorState,
  thumbWeb: unselectedColorState,
  thumbRoot: unselectedColorState,
  thumbWebAndIndexWeb: unselectedColorState,
  thumbIndexMiddle: unselectedColorState,
  thumbIndexMiddleRight: unselectedColorState,
  indexWeb: unselectedColorState,
  indexMiddle: unselectedColorState,
  indexLeftMiddleRight: unselectedColorState,
  middleIndex: unselectedColorState,
  middleLeftRingRight: unselectedColorState,
  middleRing: unselectedColorState,
  ringMiddle: unselectedColorState,
  ringLeftLittleRight: unselectedColorState,
  ringLittle: unselectedColorState,
  littleRing: unselectedColorState,
  littleOut: unselectedColorState
}

export const initialEmbroideryState = {
  id: 0,
  typeFace: { label: '未選択', value: 'unselected' },
  position: { label: '未選択', value: 'unselected' },
  color: { label: '未選択', value: 'unselected', color: '' },
  shadowColor: { label: '未選択', value: 'unselected' },
  edgeColor: { label: '未選択', value: 'unselected' },
  content: ''
}
